import app from './app';
import { USERPROFILE_SERVICE_URL, CATALOG_SERVICE_URL } from '../../libs/constants';
import directCheckout from './direct-checkout'

//POST
const addUser = (requestData) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    if ((requestData.hasOwnProperty("userType") && requestData.userType === "amplify_program_participant") && !requestData.hasOwnProperty("amplifyProgram")) {
        requestData.amplifyProgram = "Y";
    }

    await api.post(USERPROFILE_SERVICE_URL + 'users', requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch({
                type: "SET_USER_PROFILE_DATA",
                payload: response.data
            });
            response.data.customerType === "direct" && dispatch(getUser(response.data.userId));
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

//POST
const submitHelpData = (requestData, callBack) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));
    await api.post(USERPROFILE_SERVICE_URL + 'contactSupport/send', requestData)
        .then(response => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "info", messageId: "help_success" }));
            callBack();
        })
        .catch(error => {
            dispatch(app.setLoading(false));
            dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        });
};

const getUser = (userId, runInBackground = false, profilesListEdit = false) => async (dispatch, getState, api) => {
    if (!runInBackground) dispatch(app.setLoading(true));

    dispatch(setHasResponded(false));
    await api.get(USERPROFILE_SERVICE_URL + 'users/' + userId)
        .then(response => {
            if (response.data.userId) {
                const actionType = profilesListEdit ? "SET_SELECTED_USER_DATA" : "SET_USER_PROFILE_DATA"
                if (profilesListEdit) dispatch(setListEdited());
                dispatch({
                    type: actionType,
                    payload: response.data
                });
                actionType === "SET_USER_PROFILE_DATA" && response.data.customerType === "direct" && dispatch(directCheckout.checkActiveDeal(response.data.userId));
            }
            else {
                dispatch(setHasResponded(true));
            }
        })
        .catch(error => {
            if (error.response.status) {
                dispatch(setHasResponded(true));
            }
            dispatch(setHasResponded(true));
        });
    dispatch(app.setLoading(false));
};

const getVendorList = () => async (dispatch, getState, api) => {
    const headerConfig = { headers: { "DRS-Fetch-Type": "getVendorList" } };

    try {
        dispatch(app.setLoading(true));
        await api.get(CATALOG_SERVICE_URL + 'vendors', {}, headerConfig)
            .then(response => {
                dispatch({
                    type: "SET_VENDOR_LIST",
                    data: response.data
                });
            })
            .catch(error => {
                console.log("Error:", error);
            });
        dispatch(app.setLoading(false));
    } catch (error) {
        console.log("Error:", error);
    }

};

const updateUser = (userId, requestData, profilesListEdit) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));

        const headerConfig = { headers: { "DRS-Fetch-Type": "getUpdatedUserDetail" } };
        const apiUrl = profilesListEdit ? USERPROFILE_SERVICE_URL + 'updateUserProfileData' : USERPROFILE_SERVICE_URL + 'users/' + userId;
        const requestPayload = profilesListEdit ? [requestData] : requestData;
        const response = await api.post(apiUrl, requestPayload, headerConfig);

        dispatch(app.setLoading(false));

        if (profilesListEdit && response.data && response.data[0]) {
            dispatch(setListEdited());
            dispatch({
                type: "SET_SELECTED_USER_DATA",
                payload: response.data[0]
            });
        }
        else if (response.data) {
            dispatch({
                type: "SET_USER_PROFILE_DATA",
                payload: response.data,
                source: "update"
            });
            dispatch(getUser(userId));
        }

        // get updated user profile 
        // user service doesn't return user addresses on update
        //dispatch(getUser(userId, false, profilesListEdit));
        dispatch(setHasResponded(true));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};

//POST
const addAddress = (userId, requestData, runInBackground = false) => async (dispatch, getState, api) => {
    try {
        if (!runInBackground) dispatch(app.setLoading(true));

        dispatch(setHasResponded(false));
        const response = await api.post(USERPROFILE_SERVICE_URL + 'address/' + userId, requestData);//change to post and end point
        dispatch(app.setLoading(false));
        if (response.data && response.data.addresses.length > 0) {
            //dispatch(setUserAddress(response.data, index));
            dispatch(getUser(userId, runInBackground)); // get updated user profile
        }
        dispatch(setHasResponded(true));
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            dispatch(setUserProfileUpdateErrorType(error.response.data.message));
        }
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
//PUT
const updateAddress = (userId, addressId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.post(USERPROFILE_SERVICE_URL + 'address/' + userId + "/" + addressId, requestData);//change to put and end point
        dispatch(app.setLoading(false));
        if (response.data && response.data.addresses.length > 0) {
            //dispatch(setUserAddress(response.data, index));
            dispatch(getUser(userId)); // get updated user profile
        }
        dispatch(setHasResponded(true));
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            dispatch(setUserProfileUpdateErrorType(error.response.data.message));
        }
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
//DELETE
const deleteAddress = (userId, addressId) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        //const response = await api.delete(USERPROFILE_SERVICE_URL + 'address/' + userId + "/" + addressId); //change to delete and end point
        const response = await api.post(USERPROFILE_SERVICE_URL + 'deleteAddress/' + userId + "/" + addressId); //change to delete and end point
        dispatch(app.setLoading(false));
        if (response.status) {
            //dispatch(setUserAddress(null, index));
            dispatch(getUser(userId)); // get updated user profile
        }
        dispatch(setHasResponded(true));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
//POST
const addContact = (userId, requestData, runInBackground = false) => async (dispatch, getState, api) => {
    console.log("BHABANI", requestData);

    try {
        if (!runInBackground) dispatch(app.setLoading(true));

        dispatch(setHasResponded(false));
        const response = await api.post(USERPROFILE_SERVICE_URL + 'contacts/' + userId, requestData);//change to post and end point
        dispatch(app.setLoading(false));
        if (response.data) {
            dispatch(getUser(userId, runInBackground)); // get updated user profile
        }
        dispatch(setHasResponded(true));
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            dispatch(setUserProfileUpdateErrorType(error.response.data.message));
        }
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
//PUT
const updateContact = (userId, contactId, requestData) => async (dispatch, getState, api) => {
    console.log("BHABANI", requestData);
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.post(USERPROFILE_SERVICE_URL + 'contacts/' + userId + "/" + contactId, requestData);//change to put and end point
        dispatch(app.setLoading(false));
        if (response.data) {
            dispatch(getUser(userId)); // get updated user profile
        }
        dispatch(setHasResponded(true));
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            dispatch(setUserProfileUpdateErrorType(error.response.data.message));
        }
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
//DELETE
const deleteContact = (userId, contactId) => async (dispatch, getState, api) => {
    console.log("BHABANI", userId, contactId);
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.post(USERPROFILE_SERVICE_URL + 'deleteContact/' + userId + "/" + contactId); //change to delete and end point
        dispatch(app.setLoading(false));
        if (response.status) {
            dispatch(getUser(userId)); // get updated user profile
        }
        dispatch(setHasResponded(true));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
//POST
const setAvatar = (userId, requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        const response = await api.post(USERPROFILE_SERVICE_URL + 'users/avatar/' + userId, requestData, config);
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_IMAGE_URL",
            data: response.data.imageUrl
        });
        dispatch(setHasResponded(true));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
const getAmplifyCompanyData = searchText => async (dispatch, getState, api) => {
    let amplifyPartnerList = [];
    try {
        dispatch(app.setLoading(true));
        if (searchText) {
            const response = await api.get(USERPROFILE_SERVICE_URL + 'fetchPartners?searchText=' + searchText);//change to get and end point
            amplifyPartnerList = response.data.amplifyPartnerList;
        }
        dispatch({
            type: "SET_HP_PARTNER_DATA",
            data: amplifyPartnerList
        });
        dispatch(app.setLoading(false));
    } catch (error) {
        dispatch({
            type: "SET_HP_PARTNER_DATA",
            data: [] // in case of  exception of data not found
        });
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "partnerIdError" }));
        dispatch(setHasResponded(true));
    }
};

//get
const getCompanies = (requestData) => async (dispatch, getState, api) => {
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        const response = await api.get(USERPROFILE_SERVICE_URL + 'users/company?country=' + requestData.country + '&region=' + requestData.region);//change to get and end point
        dispatch(app.setLoading(false));
        dispatch({
            type: "SET_SURVEYS_COMPANIES",
            data: response.data.companyList
        });
        dispatch(setHasResponded(true));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};
//get
const getCompaniesPOST = (requestData) => async (dispatch, getState, api) => {
    ;
    try {
        dispatch(app.setLoading(true));
        dispatch(setHasResponded(false));
        if (requestData) {
            const response = await api.post(USERPROFILE_SERVICE_URL + 'users/codreport/company', requestData);
            dispatch({
                type: "SET_SURVEYS_COMPANIES",
                data: response.data.companyList
            });
        } else {
            dispatch({
                type: "SET_SURVEYS_COMPANIES",
                data: []
            });
        }
        dispatch(app.setLoading(false));

        dispatch(setHasResponded(true));
    } catch (error) {
        dispatch(app.setLoading(false));
        dispatch(setHasResponded(true));
    }
};

const getCTList = userId => async (dispatch, getState, api) => {
    try {
        const response = await api.post(USERPROFILE_SERVICE_URL + 'users/ctlist/' + userId);
        if (response.data.ctProfiles && Array.isArray(response.data.ctProfiles)) {
            dispatch({
                type: "SET_CT_LIST",
                data: response.data.ctProfiles
            });
        }
    } catch (error) {
        //
    }
};

//POST
const setSubscriptionConsent = requestData => async (dispatch, getState, api) => {
    await api.post(USERPROFILE_SERVICE_URL + 'consent', requestData);
};

const resetCompaniesList = () => {
    return {
        type: "SET_SURVEYS_COMPANIES",
        data: []
    };
}

const setHasResponded = (data) => {
    return {
        type: "SET_HAS_RESPONDED",
        data: data
    };
}
const setUserAddress = (data, index) => {
    return {
        type: "SET_USER_ADDRESS",
        data: data,
        index: index
    };
}

const setDataUpdated = (data) => {
    return {
        type: "SET_DATA_UPDATED",
        data: data
    };
}

const setListEdited = () => {
    return {
        type: "SET_LIST_EDITED"
    };
}

const setConfirmedCheckoutAsGuest = () => {
    return {
        type: 'SET_CONFIRMED_CHECKOUT_AS_GUEST'
    }
}

const setUserProfileUpdateErrorType = data => {
    return {
        type: "SET_USER_PROFILE_ERROR_TYPE",
        data: data
    };
}

const resetUserProfileContent = () => {
    return {
        type: 'RESET_USERPROFILE_CONTENT'
    }
}

const userProfileActions = {
    addUser: addUser,
    getUser: getUser,
    getVendorList: getVendorList,
    updateUser: updateUser,
    setHasResponded: setHasResponded,
    setDataUpdated: setDataUpdated,
    addAddress: addAddress,
    updateAddress: updateAddress,
    deleteAddress: deleteAddress,
    addContact: addContact,
    updateContact: updateContact,
    deleteContact: deleteContact,
    setAvatar: setAvatar,
    setConfirmedCheckoutAsGuest: setConfirmedCheckoutAsGuest,
    setUserAddress: setUserAddress,
    getCompanies: getCompanies,
    submitHelpData: submitHelpData,
    setUserProfileUpdateErrorType: setUserProfileUpdateErrorType,
    getCompaniesPOST: getCompaniesPOST,
    resetCompaniesList: resetCompaniesList,
    setSubscriptionConsent: setSubscriptionConsent,
    getAmplifyCompanyData: getAmplifyCompanyData,
    getCTList: getCTList,
    resetUserProfileContent
}

export default userProfileActions;
